import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent {
  @Input() email: string | undefined;
  @Output() modeChange = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<{ code: string }>();
  @Output() onResend = new EventEmitter<void>();
  registrationForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.registrationForm = this.fb.group({
      code: ['', [Validators.required]]
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.registrationForm.get(fieldName);
    return field ? (field.invalid && (field.dirty || field.touched)) : false;
  }

  getErrorMessage(field: string): string {
    const control = this.registrationForm.get(field);
    if (!control) return '';
    if (control.hasError('required')) {
      if (field === 'code') {
        return '验证码不能为空';
      }
    }
    return '';
  }

  handleRegistration() {
    if (this.registrationForm.valid) {
      this.onSubmit.emit({
        code: this.registrationForm.value.code,
      });
    } else {
      Object.keys(this.registrationForm.controls).forEach(key => {
        const control = this.registrationForm.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
    }
  }

  handleResend() {
    console.log('handleResend');
    this.onResend.emit();
  }
} 